import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import isNil from 'utils/isNil';
import SectionSideBySide from 'components/Sections/SectionSideBySide';
import { WebsiteImage } from 'components/TitleDescription';
import Video from 'components/Video';
import Text from 'components/Text';

const TwoSidesSection = ({
  backgroundColor,
  backgroundImageTypeWithPosition,
  reversed,
  title,
  description,
  markdownDescription,
  image,
  video,
  videoType,
  imageSideCornerType,
  videoSideBackColor,
}) => {
  const videoSide = (
    <div className="section-with-video--side">
      <div className="section-video--area">
        {!isNil(video) ? (
          <Video
            type={videoType === 'featureSection' ? 'preview-only' : 'normal'}
            width="100%"
            height={videoType === 'featureSection' ? '300px' : '700px'}
            mainSrc={video.file.url}
            previewSrc={video.file.url}
            style={{ position: 'relative', right: '0px', top: '0px' }}
          />
        ) : (
          <WebsiteImage
            className="video-side-image"
            src={image && image.length > 0 ? image[0] : null}
            alt={image && image.length > 0 ? image[0].title : title}
            marginTop="0px"
          />
        )}
      </div>
      <SectionSideCornerShape reversed={reversed} imageSideCornerType={imageSideCornerType} />
    </div>
  );

  const textSide = (
    <div>
      <h2 className="text-side-title" fontSize="normal">
        {title}
      </h2>
      {markdownDescription ? (
        <Text
          type="p"
          size="medium"
          className="text-side-description"
          dangerouslySetInnerHTML={{
            __html: markdownDescription.childMarkdownRemark.html,
          }}
        ></Text>
      ) : (
        <Text
          type="p"
          size="medium"
          className="text-side-description"
          dangerouslySetInnerHTML={{ __html: description }}
        ></Text>
      )}
    </div>
  );
  return (
    <TwoSectionSideBySide
      backgroundColor={backgroundColor}
      backgroundImageTypeWithPosition={backgroundImageTypeWithPosition}
      videoSideBackColor={videoSideBackColor}
      reversed={reversed}
      textSide={textSide}
      videoSide={videoSide}
      imageSideCornerType={imageSideCornerType}
    />
  );
};

TwoSidesSection.propTypes = {
  backgroundColor: PropTypes.string, //--blue-primary, --blue-secondary, --blue-tertiary, --blue-fourth, --white, --transparent
  backgroundImageTypeWithPosition: PropTypes.string, //none, blue-light-corner-right, blue-light-side-right, blue-dark-corner-left, blue-dark-corner-right
  reversed: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
  video: PropTypes.object,
  image: PropTypes.array,
  imageSideCornerType: PropTypes.string, //none, blue-corner-bottom, white-corner-bottom, blue-multi-top, blue-multi-bottom, teal-multi-top, teal-multi-bottom
  videoSideBackColor: PropTypes.string,
};

TwoSidesSection.defaultProps = {
  videoSideBackColor: 'white',
};

const TwoSectionSideBySide = styled(SectionSideBySide)`
  text-align: left;

  .text-side-description {
    margin-bottom: 0;
  }
  .video-side-image {
    width: 100%;
  }

  .section-with-video--side {
    float: ${props => (props.reversed ? 'left' : 'right')};

    width: 100%;
    padding: 0 0px;
    position: relative;
    .section-video--area {
      background-color: ${props => props.videoSideBackColor};
      @media (max-width: 767px) {
        padding: 0;
      }
    }
  }

  @media (max-width: 991px) {
    .ant-row-flex {
      padding: 0 28px;
    }
  }

  @media (max-width: 576px) {
    .ant-row-flex {
      padding: 0;
      flex-direction: ${props => (!props.reversed ? 'column' : 'column-reverse')};

      .ant-col {
        padding: 15px 15px 24px !important;
      }
    }
  }
`;

const SectionSideCornerShape = styled.div`
  ${({ reversed, imageSideCornerType }) => {
    switch (imageSideCornerType) {
      case 'blue-corner-bottom':
        return reversed
          ? `left: -40px; background-color: var(--secondary-green-background);`
          : `right: -40px; background-color: var(--secondary-green-background);`;
      case 'white-corner-bottom':
        return reversed
          ? `left: -40px; background-color: var(--white-color);`
          : `right: -40px; background-color: var(--white-color);`;
      default:
        return `width: 0px; height: 0px;`;
    }
  }}

  width: 211px;
  height: 211px;
  position: absolute;
  bottom: -40px;
  z-index: -1;

  @media (max-width: 768px) {
    display: none;
  }
`;

export default TwoSidesSection;
